import { IConfig } from "./Render";
export const Tr = ({className, id, children, style}:IConfig)=>
{
    return (
        <tr id={id} className={className} style={style}>{children}</tr>
    );
}